import axios from "axios";
import { apiKey } from "../config/config";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
// import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";

export default function AddLightCustomer({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const isLighMode = JSON.parse(sessionStorage.getItem("aman-admin") || 'null')?.admin ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).light_mode === "yes" : false;

  const [addGuarantor, setAddGuarantor] = useState(false);

  const [fullName, setFullName] = useState();
  const [idNum, setIdNum] = useState();
  // const [releaseDate, setReleaseDate] = useState();
  // const [source, setSource] = useState();
  const [DoB, setDoB] = useState();
  const [gender, setGender] = useState();
  const [mobileNum, setMobileNum] = useState();
  const [email, setEmail] = useState();
  const [nationality, setNationality] = useState();
  const country = lang.Saudi_Arabia;
  const [city, setCity] = useState();
  // const [states, setStates] = useState([]);
  const [fullAddress, setFullAddress] = useState();
  const [occupation, setOccupation] = useState();
  const [employer, setEmployer] = useState();
  const [designation, setDesignation] = useState();
  const [salary, setSalary] = useState();
  const [description, setDescription] = useState();
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin
  ).branch_id;
  // const [nationalities, setNationalities] = useState([]);
  const [selectedCalendar, setSelectedCalendar] = useState("arabic");

  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  const handleCalendarChange = (calendarType) => {
    setSelectedCalendar(calendarType);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    try {
      const payload = {
        full_name: fullName,
        valid_id: idNum,
        phone_no: mobileNum,
        gender: gender,
        DoB: DoB,
        nationality: nationality,
        country: country,
        city: city,
        address: fullAddress,
        email: email,
        password: "12345678",
        occupation: occupation,
        designation: designation,
        employer_name: employer,
        description: description,
        branch_id: branchId,
        salary: salary,
      };

      const apiCall = isEditMode
        ? axios.put(`${apiKey}/update-user/customer/${id}`, payload, {
            headers: { Authorization: `Bearer ${token}` },
          })
        : axios.post(`${apiKey}/create-customer`, payload, {
            headers: { Authorization: `Bearer ${token}` },
          });

      apiCall
        .then((res) => {
          if (res.status === 200) {
            setFullName("");
            setIdNum("");
            setMobileNum("");
            setGender("");
            setDoB("");
            setNationality("");
            setCity("");
            setFullAddress("");
            setEmail("");
            setOccupation("");
            setDescription("");
            setDesignation("");
            setEmployer("");
            setSalary("");
            toast.success(res.data.Message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            if (addGuarantor) {
              navigate(
                isLighMode
                  ? "/lightmode/dashboard/customer-manager/add-guarantor"
                  : "/dashboard/customer-manager/add-guarantor"
              );
            } else {
              navigate(-1);
            }
          } else {
            toast.error(res.data.Error, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          toast.error(`${err.response.data.Error}`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } catch (err) {
      console.error(err);
    }
  };

  React.useEffect(() => {
    if (isEditMode) {
      axios
        .get(`${apiKey}/get-user/customer/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.result && res.data.result.length > 0) {
            const data = res.data.result[0];
            setFullName(data.FullName);
            setIdNum(data.ValidNationalID);
            setMobileNum(data.MobilePhoneNo);
            setGender(data.Gender);
            setDoB(data.DoB ? new Date(data.DoB) : null);
            setNationality(data.Nationality);
            setCity(data.City);
            setFullAddress(data.Address);
            setEmail(data.Email);
            setOccupation(data.Occupation);
            setDescription(data.AdditionalNotes);
            setDesignation(data.Designation);
            setEmployer(data.EmployerName);
            setSalary(data.Salary);
          }
        })
        .catch((err) => console.error("Error fetching customer", err));
    }
  }, [isEditMode, id, token]);

  // useEffect(() => {
  //   try {
  //     axios
  //       .get(`${apiKey}/get-states`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         })
  //       .then((res) => {
  //         setStates(res.data.result);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //     axios
  //       .get(`${apiKey}/get-nationalities`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         })
  //       .then((res) => {
  //         setNationalities(res.data.result);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //   } catch (err) {
  //     console.error(err);
  //   }

  //   setBranchId(
  //     JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
  //   );
  // }, [token]);

  return (
    <>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="container-fluid">
          <div className="pagetitle">
            <h1>{lang.Customer_Management || "Customer Management"}</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                  >
                    <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                  </svg>
                </li>
                <li className="breadcrumb-item">
                  {lang.Customer_Management || "Customer Management"}
                </li>
                <li className="breadcrumb-item active">
                  {isEditMode ? lang.Edit_Customer || "Edit Customer" : lang.Add_New_Customer || "Add New Customer"}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container-fluid">
          <section className="section">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex mt-3 mb-3">
                      <h4 className="headingh4 fw-bold">
                        {isEditMode ? lang.Edit_Customer || "Edit Customer" : lang.Add_New_Customer || "Add New Customer"}
                      </h4>
                    </div>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      <div className="d-flex flex-column-reverse flex-lg-row mt-3 mb-3 justify-content-end">
                        <label className="select-calendar mt-3 mt-lg-0">
                          <span style={{ fontSize: "14px" }}>
                            {lang.select_calendar || "Select Calendar"}:
                          </span>
                          <div className="form-check">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="arabicRadio"
                              value="arabic"
                              checked={selectedCalendar === "arabic"}
                              onChange={() => handleCalendarChange("arabic")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="arabicRadio"
                            >
                              {lang.arabic || "Arabic"}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="gregorianRadio"
                              value="gregorian"
                              checked={selectedCalendar === "gregorian"}
                              onChange={() => handleCalendarChange("gregorian")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="gregorianRadio"
                            >
                              {lang.gregorian || "Gregorian"}
                            </label>
                          </div>
                        </label>
                        <div className="d-flex justify-content-end align-items-center">
                          <div className="form-check me-4 d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="form-check-input me-2 mt-0"
                              id="addGuarantorCheckbox"
                              checked={addGuarantor}
                              onChange={(e) => setAddGuarantor(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="addGuarantorCheckbox" style={{ fontSize: "14px", paddingTop: "2px", whiteSpace: "nowrap" }}>
                              {lang.add_guarantor || "Add Guarantor"}
                            </label>
                          </div>
                          <button
                            className="btn-save"
                            type="button"
                            onClick={handleCancel}
                          >
                            {lang.Cancel || "Cancel"}
                          </button>
                          <button type="submit" className="btn-cancel ms-4">
                            {lang.Save_And_Publish || "Save & Publish"}
                          </button>
                        </div>
                      </div>
                      <div className="row mb-3 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <label htmlFor="" className="w-100">
                            <span style={{ fontSize: "14px" }}>
                              {lang.Full_Name || "Full Name"}:
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                              required
                            />
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="" className="w-100">
                            <span style={{ fontSize: "14px" }}>
                              {lang.Valid_Identity_Number ||
                                "Valid Identity Number"}
                              :
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={idNum}
                              onChange={(e) => setIdNum(e.target.value)}
                              required
                            />
                          </label>
                        </div>
                      </div>

                      <div className="row mb-3 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <label htmlFor="" className="w-100">
                            <span style={{ fontSize: "14px" }}>
                              {lang.Mobile_Number || "Mobile Number"}:
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={mobileNum}
                              onChange={(e) => setMobileNum(e.target.value)}
                              required
                            />
                          </label>
                        </div>

                        <div className="col-lg-4">
                          <label htmlFor="" className="w-100">
                            <span style={{ fontSize: "14px" }}>
                              {lang.Date_of_Birth || "Date of Birth"}:
                            </span>
                            <DatePicker
                              className="form-control w-100"
                              containerStyle={{
                                width: "100%",
                                height: "100%",
                              }}
                              style={{
                                width: "100%",
                                height: "100%",
                                margin: "0",
                              }}
                              calendar={
                                selectedCalendar === "arabic" ? arabic : ""
                              }
                              locale={
                                selectedCalendar === "arabic" ? arabic_ar : ""
                              }
                              value={DoB}
                              onChange={(e) => {
                                const dateObject = new Date(e);
                                setDoB(dateObject);
                              }}
                            />
                          </label>
                        </div>
                      </div>
                        <div className="row mb-3 d-flex justify-content-center">
                          <div className="col-lg-4">
                            <label htmlFor="" className="w-100">
                              <span style={{ fontSize: "14px" }}>
                                {lang.Occupation || "Occupation"}:
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={occupation}
                                onChange={(e) => setOccupation(e.target.value)}
                                // required
                              />
                            </label>
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="" className="w-100">
                              <span style={{ fontSize: "14px" }}>
                                {lang.Salary || "Salary"}:
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={salary}
                                onChange={(e) => setSalary(e.target.value)}
                                // required
                              />
                            </label>
                          </div>
                        </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
